import { TabbedShowLayout, Title } from "react-admin";
import { accessCheck } from "../acl/accessCheck";
import { Settings } from "../utils/settings";
import { useMyContext } from "./myContext";
import { Box } from "@mui/material";

const Tab = TabbedShowLayout.Tab;
const MyTabbedShowLayout = ({ children, className = "", ...props }) => {
  const { acp } = useMyContext();
  const verticalTabs = Settings.getValue("verticalTabs");

  if (!acp) {
    return <Box>Could not load Access Control Provider</Box>;
  }

  className = [className, verticalTabs ? "vertical-tabs" : null]
    .filter((v) => v)
    .join(" ");

  children = accessCheck(acp, children);
  return (
    <>
      <Title title={<span>&nbsp;</span>} />
      <TabbedShowLayout className={className} {...props}>
        {children}
      </TabbedShowLayout>
    </>
  );
};

export { MyTabbedShowLayout, Tab };
